import './gh_pro_badge.scss';
import '../../config.js';
angular.module('ghProBadgeModule', ['config'])
.directive('ghProBadge', ['cnfg', (cnfg) => {
    return {
        restrict: 'E',
        template: `<div class="gh-pro-badge" ng-click="open()"><span gh-icon="lock 7a7a7a 16px normal"></span><span>Pro</span></div>`,
        link(scope, element) {
            scope.open = () => window.open(cnfg.website_url + '/upgrade', '_blank');
            element[0].addEventListener('click', e => e.stopPropagation());
        }
    };
}])
// Overlay shown when a Pro-gated feature is accessed.
// Attributes:
//   text      — feature name used in the title (default: "This feature")
//   subtitle  — override the default subtitle text
//   dark-mode — add this attribute (any value) to enable dark styling;
//               detected via CSS selector gh-pro-upgrade-screen[dark-mode],
//               no JS or extra class needed
.directive('ghProUpgradeScreen', ['cnfg', (cnfg) => {
    return {
        restrict: 'E',
        template: `
            <div class="gh-pro-upgrade-screen">
                <div class="gh-pro-upgrade-screen__card">
                    <div class="gh-pro-upgrade-screen__icon">
                        <span gh-icon="lock 3b82f6 28px normal"></span>
                    </div>
                    <h3 class="gh-pro-upgrade-screen__title">{{text || 'This feature'}} is available in Pro.</h3>
                    <p class="gh-pro-upgrade-screen__subtitle">{{subtitle || 'Unlock advanced features to customize fields exactly how you need.'}}</p>
                    <a class="gh-pro-upgrade-screen__button" ng-href="{{upgradeUrl}}" target="_blank">Upgrade to Pro</a>
                </div>
            </div>`,
        scope: { text: '@', subtitle: '@' },
        link(scope, element) {
            scope.upgradeUrl = cnfg.website_url + '/upgrade';
            const parent = element[0].parentElement;
            const prev = parent.style.overflow;
            parent.style.overflow = 'hidden';
            scope.$on('$destroy', () => { parent.style.overflow = prev; });
        }
    };
}]);
